import React, { useState, useEffect } from 'react';
import { Box, Fab, Grid, useMediaQuery, useTheme } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

const Carousel = ({ items, itemsPerStep = { xs: 2, sm: 3, md: 4 } }) => {
  const [activeStep, setActiveStep] = useState(0);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  
  // Determine current items per step based on breakpoint
  const currentItemsPerStep = isXs ? itemsPerStep.xs : isSm ? itemsPerStep.sm : itemsPerStep.md;
  const maxSteps = Math.ceil(items.length / currentItemsPerStep);

  // Reset active step when breakpoint changes
  useEffect(() => {
    setActiveStep(0);
  }, [currentItemsPerStep]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
  };

  return (
    <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
      <Fab
        onClick={handleBack}
        size="small"
        sx={{ 
          position: 'absolute', 
          left: 16, 
          top: '50%', 
          transform: 'translateY(-50%)', 
          zIndex: 1,
          backgroundColor: 'white',
          color: 'black',
          '&:hover': {
            backgroundColor: 'grey.100',
          },
        }}
      >
        <ArrowBackIos sx={{ marginLeft: '10px' }} />
      </Fab>
      <Fab
        onClick={handleNext}
        size="small"
        sx={{ 
          position: 'absolute', 
          right: 16, 
          top: '50%', 
          transform: 'translateY(-50%)', 
          zIndex: 1,
          backgroundColor: 'white',
          color: 'black',
          '&:hover': {
            backgroundColor: 'grey.100',
          },
        }}
      >
        <ArrowForwardIos />
      </Fab>
      <Box
        sx={{
          display: 'flex',
          transition: 'transform 0.3s ease',
          transform: `translateX(-${activeStep * 100}%)`,
        }}
      >
        {Array.from({ length: maxSteps }, (_, i) => (
          <Grid container spacing={2} key={i} sx={{ flexShrink: 0, width: '100%' }}>
            {items.slice(i * currentItemsPerStep, (i + 1) * currentItemsPerStep).map((item, index) => (
              <Grid item xs={12/itemsPerStep.xs} sm={12/itemsPerStep.sm} md={12/itemsPerStep.md} key={index}>
                {item.content}
              </Grid>
            ))}
          </Grid>
        ))}
      </Box>
    </Box>
  );
};

export default Carousel;